<template>
  <aside :class="{'visible': ready}" class="main">
    <div v-if="ready" class="content">
      <IconMapMarkerOrange class="icon"/>
      <label class="static">Your Local Office</label>
      <a class="name" :href="clinic.clinicUrl">{{ clinic.name }}</a>
      <label class="address">{{ clinic.address }}</label>
      <label class="address">{{ clinic.city }}, {{ clinic.state }} {{ clinic.zipCode }}</label>
      <a :href="`tel:${this.helpers().callCenterPhoneNumber()}`" class="phone"
         target="_top">{{ this.helpers().callCenterPhoneNumber() }}</a>
    </div>
  </aside>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import Services from '../mixins/services';
import IconIconStep2 from "../icons/icon-step2.vue";
import IconMapMarkerOrange from "../icons/icon-map-marker-orange.vue";

export default {
  mixins: [Services],
  props: {
    dealerId: {
      type: String,
      required: true,
    }
  },
  components: {IconMapMarkerOrange, IconStep1: IconIconStep2},
  data: function () {
    return {
      ready: false
    }
  },
  computed: mapState({
    clinic: state => state.LocalOfficeInfo.clinic,
    geoLocation: state => state.LocalOfficeInfo.geoLocation,
    clientToken: state => state.ClientToken.clientToken
  }),
  methods: {
    ...mapActions('GoogleApi', {getIpLocation: 'getIpLocation'}),
    ...mapActions('ClientToken', {getClientToken: 'getClientToken'}),
    ...mapActions('LocalOfficeInfo', {updateGeoLocation: 'updateGeoLocation'}),
    ...mapActions('LocalOfficeInfo', {getClinicInformation: 'getClinicInformation'}),
    setGeolocation(longitude, latitude) {
      this.updateGeoLocation({
        longitude: longitude,
        latitude: latitude,
      })
      this.getClinicInformation({
        Longitude: longitude,
        Latitude: latitude,
        dealerId: this.dealerId,
        clientToken: this.clientToken,
        cb: () => {
          this.ready = true;
        }
      })
    }
  },
  mounted() {
    this.getClientToken({
      cb: () => {
        let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
          this.getIpLocation({
            cb: (res) => {
              this.setGeolocation(res.lng, res.lat);
            }
          })
        } else {
          this.getIpLocation({
            cb: (res) => {
              this.setGeolocation(res.lng, res.lat);
            }
          });
          navigator.geolocation.getCurrentPosition((position) => {
            this.setGeolocation(position.coords.longitude, position.coords.latitude);
          });
        }
      }
    });
  },
}
</script>